import type { IntlShape } from 'react-intl';

/**
 * A moment as a localized date and time to the minute ("Oct 1, 2026, 08:04"),
 * through the active react-intl locale and the viewer's own time zone.
 */
export function formatDateTime(intl: IntlShape, date: Date): string {
    return intl.formatDate(date, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}
